import * as React from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';

import styles from './new-case-banner.scss';

export interface NewCaseBannerProps {
  registerNewCase?: () => void;
  textHeader: string;
  textDescription: string;
  textBtnRegisterNewCase: string;
}

export const NewCaseBanner = (props: NewCaseBannerProps) => (<div className="container main-grid">
      <div className={`row ${styles.newCasePanel}`}>
        <div className="col-md-8">
          <h1>{props.textHeader}</h1>
          <span className="description">
            {props.textDescription}
          </span>
        </div>
        <div className="col-md-4">
          <Link to={routeConstants.selectCaseType} id="register_case"
            className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}>
              {props.textBtnRegisterNewCase}
          </Link>
        </div>
      </div>
    </div>);
